import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { InfoMessageComponent } from '../../../shared/components/info-message/info-message.component';
import { Card } from 'primeng/card';
import { Button } from 'primeng/button';
import { Router } from '@angular/router';
import { APP_PATHS } from '../../../core/config/app-paths';
import { podpis } from '../../../../szafir/podpis';
import { SignatureApi } from '../../../shared/services/api/signature.api';
import { PodpisInfo } from '../../../shared/models/podpis-info';
import { DialogService } from 'primeng/dynamicdialog';
import { AuthService } from '../../../core/services/auth.service';
import { SpinnerService } from '../../../core/services/spinner.service';
import { catchError, EMPTY, tap } from 'rxjs';

@Component({
  selector: 'app-auth-electronic-signature',
  imports: [InfoMessageComponent, Card, Button],
  templateUrl: './auth-electronic-signature.html',
  styleUrl: './auth-electronic-signature.scss',
  providers: [SignatureApi, DialogService],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AuthElectronicSignature {
  readonly #router = inject(Router);
  readonly #dialogService = inject(DialogService);
  readonly #signatureApi = inject(SignatureApi);
  readonly #authService = inject(AuthService);
  readonly #spinnerService = inject(SpinnerService);

  protected navigateToLoginMethod(): void {
    this.#router.navigate([APP_PATHS.auth, APP_PATHS.auth.loginMethod]);
  }

  protected sign(): void {
    this.#spinnerService.show();
    this.#signatureApi
      .getSignatureSettings()
      .pipe(
        tap((podpisSettings: PodpisInfo) => {
          podpis.podpiszDokumentSilent(
            podpisSettings.settings,
            podpisSettings.task,
            this.#dialogService,
            this.#spinnerService,
            (value: any) => this.#authService.signInBySignature(value),
          );
        }),
        catchError(() => {
          this.#spinnerService.hide();
          throw EMPTY;
        }),
      )
      .subscribe();
  }
}
